import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api-client';

export interface MediaFormat {
  id: number;
  name: string;
  code: string | null;
  is_active: boolean;
}

/**
 * Fetch all active media formats for typeahead and filter dropdowns
 */
export function useMediaFormats() {
  return useQuery<MediaFormat[]>({
    queryKey: ['media-formats'],
    queryFn: async () => {
      const response = await get<{
        success: boolean;
        data: { mediaFormats: MediaFormat[] };
      }>('/media-formats');
      return response.data.mediaFormats;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
